import React from "react"
import { makeStyles } from "@material-ui/core/styles"
import { TableRow, TableCell } from "@material-ui/core"

const useStyles = makeStyles(theme => ({
  propName: {
    fontSize: 14,
    fontFamily: "Consolas, 'Liberation Mono', Menlo, monospace",
  },
  propType: {
    color: "rgb(34, 124, 190)",
    fontSize: 14,
    fontFamily: "Consolas, 'Liberation Mono', Menlo, monospace",
  },
  propDefault: {
    fontSize: 14,
    fontFamily: "Consolas, 'Liberation Mono', Menlo, monospace",
  },
  propDescription: {
    fontSize: 14,
  },
}))

const PropsRow = ({ name, type, defaultVal, description }) => {
  const classes = useStyles()
  return (
    <TableRow>
      <TableCell className={classes.propName}>{name}</TableCell>
      <TableCell className={classes.propType}>{type}</TableCell>
      <TableCell className={classes.propDefault}>{defaultVal}</TableCell>
      <TableCell className={classes.propDescription}>{description}</TableCell>
    </TableRow>
  )
}

export default PropsRow
